import { createSlice } from "@reduxjs/toolkit";
import {
  createExtraReducersForThunk,
  createApiThunkPrivate,
  createApiThunkPublic,
} from "../_helpers/ApiThunk";

const initialState = {
  getDiscountCouponsData: {},
  createData: {},
  editData: {},
  enableDisableData: {},
  softDeleteDiscountCouponsData: {},
  getPromotionListData: {},
  createPromotionBannerData: {},
  softDeletePromotionData: {},
  enableDisablePromotionData: {},
  updatePromotionBannerData: {},
  enableDisablePromotionByAdminData: {},
  cancelPaymentOfBannerData: {},

  getPromotionAdvertisementListData: {},
  createPromotionAdvertisementData: {},
  softDeletePromotionAdvertisementData: {},
  enableDisablePromotionAdvertisementData: {},
  updatePromotionAdvertisementData: {},
  enableDisablePromotionAdvertisementByAdminData: {},
  cancelPaymentOfAdvertisementData: {},
};

export const getDiscountCoupons = createApiThunkPrivate(
  "getDiscountCoupons",
  "/discount-coupons/getList",
  "GET",
);
export const createDiscountCoupons = createApiThunkPrivate(
  "createDiscountCoupons",
  "/discount-coupons/create",
  "POST",
);
export const editDiscountCoupons = createApiThunkPrivate(
  "editDiscountCoupons",
  "/discount-coupons/update",
  "PUT",
);
export const enableDisableDiscountCoupons = createApiThunkPrivate(
  "enableDisable",
  "/discount-coupons/enableDisable",
  "PUT",
);
export const softDeleteDiscountCoupons = createApiThunkPrivate(
  "softDeleteDiscountCoupons",
  "/discount-coupons/softDelete",
  "DELETE",
);
///////////////Promotional Banners///////////////
export const getPromotionList = createApiThunkPrivate(
  "getPromotionList",
  "/promotions-banner/getList",
  "GET",
);
export const createPromotionBanner = createApiThunkPrivate(
  "createPromotionBanner",
  "/promotions-banner/create",
  "POST",
);
export const softDeletePromotion = createApiThunkPrivate(
  "softDeletePromotion",
  "/promotions-banner/softDelete",
  "DELETE",
);
export const enableDisablePromotion = createApiThunkPrivate(
  "enableDisablePromotion",
  "/promotions-banner/enableDisable",
  "PUT",
);
export const updatePromotionBanner = createApiThunkPrivate(
  "updatePromotionBanner",
  "/promotions-banner/update",
  "PUT",
);
export const enableDisablePromotionByAdmin = createApiThunkPrivate(
  "enableDisablePromotionByAdmin",
  "/promotions-banner/enableDisableByAdmin",
  "PUT",
);
export const cancelPaymentOfBanner = createApiThunkPrivate(
  "cancelPaymentOfBanner",
  "/promotions-banner/cancelPaymentOfBanner",
  "POST",
);

export const verifyFlutterwaveTransaction = createApiThunkPublic(
  "verifyFlutterwaveTransaction",
  "/order/flutterwave/verify",
  "POST",
);

export const autoCancelFlutterwaveTransactions = createApiThunkPublic(
  "autoCancelFlutterwaveTransactions",
  "/order/flutterwave/autoCancel",
  "POST",
);

////Promotion Advertisement /////////////

export const getPromotionAdvertisementList = createApiThunkPrivate(
  "getPromotionAdvertisementList",
  "/promotions-advertisement/getList",
  "GET",
);
export const createPromotionAdvertisement = createApiThunkPrivate(
  "createPromotionAdvertisement",
  "/promotions-advertisement/create",
  "POST",
);
export const softDeletePromotionAdvertisement = createApiThunkPrivate(
  "softDeletePromotionAdvertisement",
  "/promotions-advertisement/softDelete",
  "DELETE",
);
export const enableDisablePromotionAdvertisement = createApiThunkPrivate(
  "enableDisablePromotionAdvertisement",
  "/promotions-advertisement/enableDisable",
  "PUT",
);
export const updatePromotionAdvertisement = createApiThunkPrivate(
  "updatePromotionAdvertisement",
  "/promotions-advertisement/update",
  "PUT",
);
export const enableDisablePromotionAdvertisementByAdmin = createApiThunkPrivate(
  "enableDisablePromotionAdvertisementByAdmin",
  "/promotions-advertisement/enableDisableByAdmin",
  "PUT",
);

export const cancelPaymentOfAdvertisement = createApiThunkPrivate(
  "cancelPaymentOfAdvertisement",
  "/promotions-advertisement/cancelPaymentOfAdvertisement",
  "POST",
);

const promotionsSlice = createSlice({
  name: "promotions",
  initialState,
  extraReducers: (builder) => {
    createExtraReducersForThunk(
      builder,
      getDiscountCoupons,
      "getDiscountCouponsData",
    );
    createExtraReducersForThunk(builder, createDiscountCoupons, "createData");
    createExtraReducersForThunk(builder, editDiscountCoupons, "editData");
    createExtraReducersForThunk(
      builder,
      enableDisableDiscountCoupons,
      "enableDisableData",
    );
    createExtraReducersForThunk(
      builder,
      softDeleteDiscountCoupons,
      "softDeleteDiscountCouponsData",
    );

    /////Promotional Banners/////
    createExtraReducersForThunk(
      builder,
      getPromotionList,
      "getPromotionListData",
    );
    createExtraReducersForThunk(
      builder,
      createPromotionBanner,
      "createPromotionBannerData",
    );
    createExtraReducersForThunk(
      builder,
      softDeletePromotion,
      "softDeletePromotionData",
    );
    createExtraReducersForThunk(
      builder,
      enableDisablePromotion,
      "enableDisablePromotionData",
    );
    createExtraReducersForThunk(
      builder,
      updatePromotionBanner,
      "updatePromotionBannerData",
    );
    createExtraReducersForThunk(
      builder,
      enableDisablePromotionByAdmin,
      "enableDisablePromotionByAdminData",
    );
    createExtraReducersForThunk(
      builder,
      cancelPaymentOfBanner,
      "cancelPaymentOfBannerData",
    );

    /////Promotion Advertisement/////

    createExtraReducersForThunk(
      builder,
      getPromotionAdvertisementList,
      "getPromotionAdvertisementListData",
    );
    createExtraReducersForThunk(
      builder,
      createPromotionAdvertisement,
      "createPromotionAdvertisementData",
    );
    createExtraReducersForThunk(
      builder,
      softDeletePromotionAdvertisement,
      "softDeletePromotionAdvertisementData",
    );
    createExtraReducersForThunk(
      builder,
      enableDisablePromotionAdvertisement,
      "enableDisablePromotionAdvertisementData",
    );
    createExtraReducersForThunk(
      builder,
      updatePromotionAdvertisement,
      "updatePromotionAdvertisementData",
    );
    createExtraReducersForThunk(
      builder,
      enableDisablePromotionAdvertisementByAdmin,
      "enableDisablePromotionAdvertisementByAdminData",
    );
    createExtraReducersForThunk(
      builder,
      cancelPaymentOfAdvertisement,
      "cancelPaymentOfAdvertisementData",
    );

  }
  
});

export default promotionsSlice.reducer;
